import Ajax from 'js/utils/ajax/ajax.js';

import { ApiUser } from 'src/interfaces/interfaces.generated';

export const updatePasswordWSUser = (userId: number): Promise<ApiUser> =>
  Ajax.patch(`/useradmin/v1/wsusers/${userId}/password`);
